import cls from 'classnames';
import { openModal } from 'components/Modals/actions';
import { ROUTES } from 'constants/routes';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import MyOceanIcon from 'svg/MyOceanIcon';
import { MODALS } from '../Modals/consts';
import { LITE_URL } from './consts';
import useStyles from './styles';

interface IProps {
}

const Header: React.FC<IProps> = () => {
  const classes = useStyles();
  const backgroundRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();

  const handleSalesClick = () => {
    dispatch(openModal({ modalId: MODALS.CONTACT_SALES }));
  };

  return (
    <header className={classes.root}>
      <div ref={backgroundRef} className={classes.background} />
      <div className={classes.header}>
        <Link to={ROUTES.ROOT} className={classes.logo}>
          <MyOceanIcon />
        </Link>
        <div className={cls(classes.menu, classes.menuAdditional)}>
          <a className={classes.menuItem} href={LITE_URL} target="_blank" rel="noreferrer">
            Log in
          </a>
          <button type="button" className={classes.contactSalesButton} onClick={handleSalesClick}>
            Contact sales
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
